import { Map } from 'immutable';

import {
  ContainerEditActionTypes,
  ContainerEditActions,
} from './container-edit.actions';
import { ContainerActions } from './container.actions';
import { CreateOrUpdate } from './create-or-update';

export function sectionsBeingEditedReducer(
  state: Map<string, CreateOrUpdate>,
  action: ContainerActions | ContainerEditActions,
): Map<string, CreateOrUpdate> {
  switch (action.type) {
    case ContainerEditActionTypes.CANCEL_CREATE_SECTION:
    case ContainerEditActionTypes.CANCEL_UPDATE_SECTION:
    case ContainerEditActionTypes.CONFIRM_CREATE_SECTION:
    case ContainerEditActionTypes.CONFIRM_UPDATE_SECTION: {
      const { id } = action.payload;
      return state.remove(id);
    }

    case ContainerEditActionTypes.CREATE_SECTION: {
      const { id } = action.payload;
      return state.merge({ [id]: CreateOrUpdate.CREATE });
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_SECTION: {
      const { section, descendantSections } = action.payload;
      return state.remove(section.id).removeAll(descendantSections);
    }

    case ContainerEditActionTypes.UPDATE_SECTION: {
      const { id } = action.payload;
      return state.merge({ [id]: CreateOrUpdate.UPDATE });
    }

    default: {
      return state;
    }
  }
}
